import { ShieldCheckIcon } from '@atgfr8/icons';

export const InsuranceSkeleton = (props: { label: string }) => {
  return (
    <div class="border border-gray-300 rounded-lg shadow-xs bg-gray-100 p-3 relative mt-2">
      <div class="absolute inset-0 flex items-center justify-center  z-10 text-gray-500 font-semibold">
        Click 'get rates' to see policy details
      </div>
      <div class="flex items-center gap-2">
        <ShieldCheckIcon color="#9CA3AF" />
        <span class="text-gray-500 font-medium">{props.label}</span>
      </div>
      <div class="h-4 w-full bg-gray-300 rounded-sm my-2"></div>
      <div class="flex items-center justify-between flex-wrap my-2">
        <div class="h-4 w-16 bg-gray-300 rounded-sm"></div>
        <div class="h-4 w-16 bg-gray-300 rounded-sm"></div>
      </div>
      <div class="flex items-center justify-between flex-wrap my-2">
        <div class="h-4 w-24 bg-gray-300 rounded-sm"></div>
        <div class="h-4 w-20 bg-gray-300 rounded-sm"></div>
      </div>
      <div class="flex items-center justify-between flex-wrap my-2">
        <div class="h-4 w-20 bg-gray-300 rounded-sm"></div>
        <div class="h-4 w-20 bg-gray-300 rounded-sm"></div>
      </div>
      <div class="flex items-center justify-between flex-wrap my-2">
        <div class="h-4 w-28 bg-gray-300 rounded-sm"></div>
        <div class="h-4 w-20 bg-gray-300 rounded-sm"></div>
      </div>
      <div class="flex items-center justify-between flex-wrap my-2">
        <div class="h-4 w-16 bg-gray-300 rounded-sm"></div>
        <div class="h-4 w-20 bg-gray-300 rounded-sm"></div>
      </div>
      <div class="h-4 w-full bg-gray-300 rounded-sm my-2"></div>
    </div>
  );
};
